import { useMemo, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { faNum } from "@/lib/format";

export const CalculatorModal = ({ open, onOpenChange, coins }) => {
  const [coinId, setCoinId] = useState("");
  const [count, setCount] = useState(1);
  const [side, setSide] = useState("sell");

  const coin = useMemo(() => coins.find((c) => c.id === coinId) || coins[0], [coins, coinId]);
  const total = coin ? (side === "buy" ? coin.buy : coin.sell) * (Number(count) || 0) : 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="gold-calculator-modal" className="glass border-amber-500/25 text-stone-100 sm:max-w-md" dir="rtl">
        <DialogHeader>
          <DialogTitle className="text-amber-200">محاسبه‌گر سریع سکه</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <label className="block">
            <span className="mb-1.5 block text-xs text-stone-400">نوع سکه</span>
            <select
              data-testid="calc-select-coin"
              value={coin?.id || ""}
              onChange={(e) => setCoinId(e.target.value)}
              className="w-full rounded-lg border border-amber-500/25 bg-black/50 px-3 py-2.5 text-sm text-amber-100 outline-none focus:border-amber-400"
            >
              {coins.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </label>
          <label className="block">
            <span className="mb-1.5 block text-xs text-stone-400">تعداد</span>
            <input
              data-testid="calc-input-count"
              type="number"
              min="0"
              value={count}
              onChange={(e) => setCount(e.target.value)}
              className="w-full rounded-lg border border-amber-500/25 bg-black/50 px-3 py-2.5 text-sm text-amber-100 outline-none focus:border-amber-400"
            />
          </label>
          <div className="grid grid-cols-2 gap-2">
            {[
              { k: "buy", label: "خرید از شما" },
              { k: "sell", label: "فروش به شما" },
            ].map((s) => (
              <button
                key={s.k}
                data-testid={`calc-side-${s.k}`}
                onClick={() => setSide(s.k)}
                className={`rounded-lg border px-3 py-2.5 text-sm transition-colors duration-300 ${
                  side === s.k
                    ? "border-amber-400 bg-amber-500 text-black font-bold"
                    : "border-amber-500/25 text-stone-300 hover:border-amber-400"
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
          <div className="rounded-xl border border-amber-500/25 bg-amber-500/5 px-4 py-5 text-center">
            <span className="block text-xs text-stone-400">مبلغ {side === "buy" ? "خرید از شما" : "فروش به شما"}</span>
            <span data-testid="calc-total-price" className="mt-1 block text-2xl font-black text-amber-300">
              {faNum(total)}
              <small className="mr-2 text-xs font-normal text-stone-500">تومان</small>
            </span>
          </div>
          <p className="text-center text-[10px] text-stone-600">بر اساس نرخ تابلو · نرخ نهایی هنگام معامله اعلام می‌شود</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
